import { render } from "./ActionDialog.vue?vue&type=template&id=5ddb596a"
import script from "./ActionDialog.vue?vue&type=script&lang=ts"
export * from "./ActionDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script